import React from 'react';
import './TriBanner.css';

const bannersByCountry = {
    ARG: [
        {
            src: `${process.env.PUBLIC_URL}/banner/triBanner/argentina/tribanner1.jpg`,
            alt: 'SolarBox',
            href: 'https://www.solarbox.com.ar/',
        },
        {
            src: `${process.env.PUBLIC_URL}/banner/triBanner/argentina/elo.jpg`,
            alt: 'Solution Box',
            href: 'https://www.solutionbox.com.ar/marcas/ELO',
        },
        {
            src: `${process.env.PUBLIC_URL}/banner/triBanner/argentina/supermicro.jpg`,
            alt: 'Solution Box',
            href: 'https://www.solutionbox.com.ar/contacto',
        },
    ],
    UY: [
        {
            src: `${process.env.PUBLIC_URL}/banner/triBanner/uruguay/banner_cisco_2.jpg`,
            alt: 'Cisco',
            href: 'https://www.solutionbox.com.uy/',
        },
        {
            src: `${process.env.PUBLIC_URL}/banner/triBanner/uruguay/banner_apc.jpg`,
            alt: 'APC',
            href: 'https://www.solutionbox.com.uy/marcas/006',
        },
        {
            src: `${process.env.PUBLIC_URL}/banner/triBanner/uruguay/tribanner3.jpg`,
            alt: 'NSX',
            href: 'https://nsx.com.ar/',
        },
    ],
};

const TriBanner = () => {
    const country = process.env.REACT_APP_COUNTRY;
    const banners = bannersByCountry[country] || bannersByCountry.ARG;

    return (
        <div className="tribanner">
            {banners.map((banner, index) => (
                <a
                    key={index}
                    className="tribanner__item"
                    href={banner.href}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        className="tribanner__img"
                        src={banner.src}
                        alt={banner.alt}
                        loading="lazy"
                    />
                </a>
            ))}
        </div>
    );
};

export default TriBanner;
